import { Notification } from '@wetransfer/transfer/store/types';
import { TransferNotification } from '@wetransfer/transfer/transfer-bundle/types/notification';

export default {
  panel: {} as Notification,
  transfer: {} as Record<string, never> | TransferNotification,
  popover: {},
};
